import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { Alert, Dialog, Text, useToast } from "@flat-ui";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { useCompanyId } from "@context-providers/company-id-provider";
import { deleteProject } from "@store/projects/projects-slice-thunk";
import { useAppDispatch } from "@store/store-helper";
import { ProjectEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useState } from "react";
import { UtilsTypes } from "@stellar/utils";
/** Renders the delete button and delete the project on click with confirmation dialog */
export function DeleteProject({
  project,
  onClose
}) {
  const dispatch = useAppDispatch();
  const {
    openToast
  } = useToast();
  const companyId = useCompanyId();
  const {
    navigateToProjects
  } = useAppNavigation();
  const {
    trackEvent
  } = useTrackEvent();
  const [isProcessing, setIsProcessing] = useState(false);
  async function deleteSelectedProject() {
    trackEvent({
      name: ProjectEvents.deleteProject
    });
    setIsProcessing(true);
    try {
      // Using unwrap makes sure that showToast is only shown if there is no error
      await dispatch(deleteProject({
        companyId,
        projectId: project.id
      })).unwrap();
      openToast({
        title: "Project deleted successfully"
      });
      navigateToProjects({
        companyId,
        projectStatus: UtilsTypes.ProjectArchivingState.archived
      });

      // error is handled by the deleteProject thunk in errors-slice
    } finally {
      setIsProcessing(false);
    }
  }
  return <>
      {/* Dialog to confirm before delete */}
      <Dialog title="Delete Project" confirmText="Delete" open={true} onConfirm={deleteSelectedProject} onCancel={onClose} showSpinner={isProcessing} variant="danger">
        <Text variant="bodyM" sx={{
        color: "text.primary",
        mb: SPACE_ELEMENTS_OF_MODAL
      }}>
          When deleting the{" "}
          <var>
            <b>{project.name}</b>
          </var>{" "}
          project, all data will be lost.
        </Text>

        <Alert variant="warning" title="Deleted projects cannot be recovered." />
      </Dialog>
    </>;
}